/**
 * Estilos base do formulário de Plano de Ação — compartilhados pelo MPA (Novo Plano)
 * e pelo editor de ações embutido na BAIXA da TARP (GUPM-213). Migrados de
 * `features/planos/planoForm.ts` para `components/` para não fazer uma feature
 * importar da outra (architecture.md).
 */
const inputBase =
  'w-full rounded-lg border border-jf-border px-2.5 py-1.5 text-sm text-white ' +
  'placeholder:text-jf-dim focus:border-jf-yellow focus:outline-none';
// Campo em tom MÉDIO (`bg-jf-surface`) — para uso DENTRO de um container escuro: o card da
// ação (Novo Plano) ou a Section `bg-jf-surface2`. O tom médio contrasta com o fundo escuro
// (mesmo padrão das seções de dados do form de Troca de Plantão).
export const inputCls = `${inputBase} bg-jf-surface`;
// Campo ESCURO (`bg-jf-surface2`) — para uso FLAT direto num bloco de tom médio (baixa da
// TARP), igual ao textarea de parecer (FIELD_CLS). O campo escuro já contrasta com o bloco
// claro, dispensando um card em volta — evita "card dentro de card" (GUPM-213, ajuste do dono).
export const inputDarkCls = `${inputBase} bg-jf-surface2`;
export const labelCls = 'text-[10px] font-bold uppercase tracking-wider text-jf-dim';

/** Cores da faixa de prazo (curto/médio/longo) — espelha `prazoDiasUteis`. */
export const FAIXA_COLOR = { curto: '#ef4444', medio: '#eab308', longo: '#22c55e' } as const;
